import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchPettyCashCommonRequestList = createAsyncThunk(
	"fetchPettyCashCommonRequestList",
	async ({ filters }) => {
		const formatDate = (date) => (date && date.isValid && date.isValid() ? date.format("YYYY-MM-DD") : "");

		const params = new URLSearchParams({
			page: filters?.page ?? 1,
			limit: filters?.limit ?? 10,
			keyword: filters?.keyword ?? "",
			status_id: filters?.status_id ?? "",
			department: filters?.department_id ?? "",
			start_date: filters?.dateRange && filters.dateRange[0] ? formatDate(filters.dateRange[0]) : "",
			end_date: filters?.dateRange && filters.dateRange[1] ? formatDate(filters.dateRange[1]) : "",
			user_uuid: filters?.user_uuid ?? "",
		});

		try {
			const response = await axiosHttp.get(`petty-cash/common-requests?${params}`);
			return response.data;
		} catch (error) {
			throw error;
		}
	}
);

const PettyCashCommonRequestListSlice = createSlice({
	name: "PettyCashCommonRequestListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		limit: 10,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchPettyCashCommonRequestList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchPettyCashCommonRequestList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload?.pagination?.page || 1;
			state.limit = action.payload?.pagination?.limit || 10;
			state.total = action.payload?.pagination?.total || (action.payload?.data ? action.payload.data.length : 0);
		});

		builder.addCase(fetchPettyCashCommonRequestList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default PettyCashCommonRequestListSlice.reducer;
